import { Room, Participant } from 'livekit-client';

/**
 * Находит участника по LiveKit identity в комнате.
 *
 * @param room
 * @param identity  Participant identity
 * @returns Participant или null если не найден
 */
export const findParticipantByIdentity = (room: Room, identity: string): Participant | null => {
    if (!identity || identity.trim() === '') return null;

    if (room.localParticipant.identity === identity) {
        return room.localParticipant;
    }

    const remote = room.remoteParticipants.get(identity);
    return remote ?? null;
};
